import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { VacancyComponent } from './vacancy.component';
import { vacancyRoutingoModule } from './vacancy-routing.module';
@NgModule({
  imports: [
    vacancyRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [VacancyComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class vacancyModule { }
